import {Constructor} from "../../global/constructor";
import ObjectModelBuilderModel from "../models/tracked/objectModelBuilderModel";
import {Hash} from "../interfaces/hashInterfaces";
import ObjectModelPermissionPermittee from "~/models/objectModelPermissionPermittee";
import {ObjectHelper} from "../helpers/objectHelper";
import {IObjectModelPermissionPermitteeContainer} from '~/interfaces/objectModelInterfaces'
import {IPermittee} from "~/interfaces/permitteeInterfaces";
import {ArrayHelper} from "~/helpers/arrayHelper";

export default function ObjectModelPermissionPermitteeContainer<TBase extends Constructor<ObjectModelBuilderModel>>(Base: TBase) {
  return class ObjectModelContainer extends Base implements IObjectModelPermissionPermitteeContainer {
    permission_permittees: Hash<ObjectModelPermissionPermittee> = {};

    get permissionPermitteesArray(): ObjectModelPermissionPermittee[] {
      return this.sortProperty('permission_permittees');
    }

    get hasPermissionPermittees(): boolean {
      return Object.keys(this.permission_permittees).length > 0;
    }

    findPermissionPermittee(attrs: Partial<Pick<IPermittee, 'reference_id' | 'reference_type'>>): IPermittee | null {
      return this.permissionPermitteesArray.find(permittee => {
        if (ObjectHelper.isAnyMatch(attrs, permittee)) return permittee
      })
    }

    updatePermissionPermitteePositions(movedPermittee: ObjectModelPermissionPermittee, position: number) {
      ArrayHelper.updatePositionsByProp(this.permissionPermitteesArray, movedPermittee, position, 'sort_order');
    }
  };
}